import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pay_course_pop" }
const _hoisted_2 = { class: "pay_head" }
const _hoisted_3 = { class: "pay_title" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "pay-course" }
const _hoisted_6 = { class: "course_list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "course_cover" }
const _hoisted_9 = {
  key: 0,
  class: "course_type_name"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "c_info" }
const _hoisted_12 = { class: "course_title" }
const _hoisted_13 = { class: "course_bom" }
const _hoisted_14 = {
  key: 0,
  class: "cb_left"
}
const _hoisted_15 = { class: "cb_price2" }
const _hoisted_16 = {
  key: 1,
  class: "cb_left"
}
const _hoisted_17 = { class: "cb_value" }
const _hoisted_18 = { class: "cb_price" }
const _hoisted_19 = {
  key: 2,
  class: "cb_left"
}
const _hoisted_20 = { class: "cb_value" }
const _hoisted_21 = { class: "cb_price" }
const _hoisted_22 = { class: "cb_right" }

import { computed, onBeforeUnmount, onDeactivated } from 'vue'
import { useThemeColorWithAlpha, useThemeColor, useThemeId } from '@/utils/theme'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

interface GoodsItem {
  id: string
  spuType: number
  coverImgUrl?: string
  spuName?: string
  isCashPay: number
  defaultPayType: number
  price?: number
  isIntegralPay: number
  integral?: number
  isCombinationPay: number
  combinationIntegral?: number
  combinationPrice?: number
  buyTotal?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PayCoursePopup',
  props: {
  show: {
    type: Boolean,
    default: false
  },
  categoryName: {
    type: String,
    default: ''
  },
  goodsInfo: {
    type: Array as () => GoodsItem[],
    default: () => []
  }
},
  emits: ['update:show', 'changeShow'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "31a59038": (_unref(themeLinearColorWithAlpha)),
  "61dfef59": (_unref(themeColor)),
  "735400df": (_unref(themeColorWithAlpha)),
  "19b59c16": (payThemeTextColor.value)
}))

const props = __props

const { t } = useI18n()
const router = useRouter()
const themeColor = useThemeColor()
const themeType = useThemeId()
const themeColorWithAlpha = useThemeColorWithAlpha(0.2)
const themeLinearColorWithAlpha = useThemeColorWithAlpha(0.3)
const emits = __emit
const popShow = computed({
  get: () => props.show,
  set: (v: boolean) => {
    emits('update:show', v)
    emits('changeShow', v) // 兼容父级若仍监听 change-show
  }
})
const closePopup = () => {
  popShow.value = false
}
const goShopIndex = () => {
  popShow.value = false
  router.push({ path: '/shopIndex' })
}
const goShopDetail = (id: string) => {
  popShow.value = false
  router.push({ path: '/shopDetail', query: { id } })
}
onDeactivated(() => {
  popShow.value = false
})
onBeforeUnmount(() => {
  popShow.value = false
})
const getSpu = computed(() => (spuType: number) => {
  if (spuType === 1) return t('shop_course')
  if (spuType === 2) return t('shop_entity')
  if (spuType === 3) return t('shop_service')
  return ''
})

const payThemeTextColor = computed(() => {
  let color = ''
  switch (themeType.value) {
    case 'red':
      color = '#850000'
      break
    case 'blue':
      color = '#003685'
      break
    case 'orange':
      color = '#855500'
      break
  }
  return color
})

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: popShow.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((popShow).value = $event)),
    round: "",
    "z-index": 3000,
    position: "bottom",
    style: { maxHeight: '70vh', overflow: 'hidden' },
    duration: popShow.value ? '0.2' : '0.2'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.categoryName || _ctx.$t('all')), 1),
          _createElementVNode("div", {
            class: "close_box",
            onClick: _withModifiers(closePopup, ["stop"])
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "iconfont icon-icon_wode_wodepeixun_guanbi pay_close" }, null, -1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "pay-m" }, [
              _createElementVNode("i", { class: "iconfont icon-wodedingdan icon_c" })
            ], -1)),
            _createElementVNode("div", {
              class: "pay-desc",
              onClick: goShopIndex
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('more_course_to_exchange')), 1),
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "iconfont icon-icon_tiaozhuan pay-jump" }, null, -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.goodsInfo, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "course_item",
                key: item.id,
                onClick: ($event: any) => (goShopDetail(item.id))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  (getSpu.value(item.spuType))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(getSpu.value(item.spuType)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("img", {
                    class: "course_img",
                    src: item.coverImgUrl || ''
                  }, null, 8, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(item.spuName || ''), 1),
                  _createElementVNode("div", _hoisted_13, [
                    (item.isCashPay === 1 && item.defaultPayType === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "cb_unit" }, "￥", -1)),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(item.price || 0), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.isIntegralPay === 1 && item.defaultPayType === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(item.integral || 0), 1),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('shop_integral')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.isCombinationPay === 1 && item.defaultPayType === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(item.combinationIntegral || 0), 1),
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('shop_integral')) + "+¥" + _toDisplayString(item.combinationPrice || 0), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(item.buyTotal || 0) + _toDisplayString(_ctx.$t('shop_bought_count')), 1)
                ])
              ], 8, _hoisted_7))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show", "duration"]))
}
}

})